import { createRoot } from 'react-dom/client';

// third party
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { QueryClientProvider } from '@tanstack/react-query';

// project imports
// import * as serviceWorker from 'serviceWorker';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import App from 'App';
// import { store } from 'store';
import store from './redux/Store';

// style + assets
import 'assets/scss/style.scss';
import config from './config';
import 'index.css';

// Tanstack QueryClient
import { queryClient } from './queryClient';

// ==============================|| REACT DOM RENDER  ||============================== //

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript

root.render(
    <Provider store={store}>
        <QueryClientProvider client={queryClient}>
            <BrowserRouter basename={config.basename}>
                <App />
            </BrowserRouter>
        </QueryClientProvider>
    </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
serviceWorkerRegistration.unregister();
